import { memo, type ReactNode } from 'react';

export interface ConditionallyRenderProps {
  readonly children: ReactNode;
  readonly fallback?: (() => ReactNode) | ReactNode;
  readonly show: boolean;
}

/**
 * A component that shows or hides it's children depending on the value of either the 'show' prop,
 * {@link boolean}.
 */
export const ConditionallyRender = memo(function ConditionallyRender({
  children,
  fallback,
  show,
}: ConditionallyRenderProps): ReactNode {
  if (show) {
    return children;
  }
  const fb = fallback ?? null;
  return typeof fb === 'function' ? fb() : fb;
});
